<script lang="ts" setup>
import { computed, ref, watch } from 'vue'

import AdminSidebar from '@/layouts/admin/AdminSidebar.vue'
import AdminTopbar from '@/layouts/admin/AdminTopbar.vue'
import { useLayout } from '@/layouts/admin/layout.ts'
import SiteFooter from '@/layouts/site/SiteFooter.vue'

// layout state
const { layoutConfig, layoutState, isSidebarActive, isSidebarExpanded } = useLayout()

// Use proper typing for the listener
const outsideClickListener = ref<((event: MouseEvent) => void) | null>(null)

watch(isSidebarActive, (newVal) => {
  if (newVal) {
    bindOutsideClickListener()
  } else {
    unbindOutsideClickListener()
  }
})

const containerClass = computed(() => {
  return {
    'layout-overlay': layoutConfig.menuMode === 'overlay',
    'layout-static': layoutConfig.menuMode === 'static',
    'layout-static-inactive':
      layoutState.staticMenuDesktopInactive && layoutConfig.menuMode === 'static',
    'layout-overlay-active': layoutState.overlayMenuActive,
    'layout-mobile-active': layoutState.staticMenuMobileActive,
  }
})

function bindOutsideClickListener() {
  if (!outsideClickListener.value) {
    outsideClickListener.value = (event: MouseEvent) => {
      if (isOutsideClicked(event)) {
        layoutState.overlayMenuActive = false
        layoutState.staticMenuMobileActive = false
        layoutState.menuHoverActive = false
      }
    }
    document.addEventListener('click', outsideClickListener.value)
  }
}

function unbindOutsideClickListener() {
  if (outsideClickListener.value) {
    document.removeEventListener('click', outsideClickListener.value)
    outsideClickListener.value = null
  }
}

function isOutsideClicked(event: MouseEvent): boolean {
  const target = event.target as HTMLElement
  const sidebarEl = document.querySelector('.layout-sidebar')
  const topbarEl = document.querySelector('.layout-menu-button')

  return !(
    (sidebarEl && (sidebarEl === target || sidebarEl.contains(target))) ||
    (topbarEl && (topbarEl === target || topbarEl.contains(target)))
  )
}
</script>

<template>
  <div :class="containerClass" class="layout-wrapper bg-neutral-100">
    <AdminTopbar />
    <AdminSidebar :is-sidebar-expanded="isSidebarExpanded" />
    <div class="layout-main-container">
      <div class="layout-main">
        <RouterView />
      </div>
    </div>
    <div class="layout-mask animate-fadein"></div>
    <SiteFooter />
  </div>
  <Toast />
</template>

<style lang="scss" scoped></style>
